import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Checkbox,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomDropzone from "components/Dropzone";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import api from "_api";
import Swal from "sweetalert2";
import "assets/css/modal.css";
import { CreateInput } from "thai-address-autocomplete-react";
import SaveIcon from "assets/images/SaveIcon.svg";

const InputThaiAddress = CreateInput();

// Mock category options
const categoryOptions = [
  { label: "นาย", id: 1 },
  { label: "นาง", id: 2 },
  { label: "นางสาว", id: 3 },
];

const companyOptions = [
  { label: "โรงจำนำ", id: 1 },
  { label: "ร้านทอง", id: 2 },
  { label: "ร้านเพชร", id: 3 },
  { label: "ร้านของเก่า", id: 4 },
  { label: "อื่น ๆ", id: 5 },
  { label: "ร้านรถมือสอง", id: 6 },
  { label: "ร้านจำนองที่ดิน", id: 7 },
];

// Validation schema
const validationSchema = Yup.object({
  company_name: Yup.string().required("กรุณากรอกชื่อบริษัท"),
  tax_id_number: Yup.string().required("กรุณากรอกเลขประจําตัวผู้เสียภาษี"),
  company_type_id: Yup.object().nullable().required("กรุณาเลือกประเภทบริษัท"),
  // owner_prefix: Yup.string().required("กรุณาระบุคำนำหน้า"),
  owner_name: Yup.string().required("กรุณากรอกชื่อ-สกุล"),
  contact: Yup.string().required("กรุณากรอกชื่อผู้ติดต่อ"),
  phone: Yup.string().required("กรุณากรอกเบอร์ติดต่อ"),
  email: Yup.string().required("กรุณากรอกอีเมล"),
  alley: Yup.string().required("กรุณากรอกที่อยู่"),
  province_id: Yup.string().required("กรุณาระบุจังหวัด"),
  amphure_id: Yup.string().required("กรุณาระบุอําเภอ"),
  district_id: Yup.string().required("กรุณาระบุตําบล"),
  zipcode: Yup.string().required("กรุณาระบุรหัสไปรษณีย์"),
});

const productFields = [
  { label: "ชื่อ", name: "company_name", type: "text", required: true },
  {
    label: "เลขประจำตัวผู้เสียภาษีอากร",
    name: "tax_id_number",
    type: "text",
    required: true,
  },
];

const productFields2 = [
  {
    label: "ประเภทร้าน",
    name: "company_type_id",
    type: "autocomplete",
    required: true,
  },
  {
    label: "การจดทะเบียนบริษัท",
    name: "company_license",
    type: "checkbox",
    required: true,
  },
  { label: "ชื่อผู้ติดต่อ", name: "contact", type: "text", required: true },
  { label: "เบอร์โทรศัพท์", name: "phone", type: "text", required: true },
  { label: "E-mail", name: "email", type: "email", required: true },
  {
    label: "ที่อยู่ เลขที่",
    name: "alley",
    type: "text",
    required: true,
  },
  { label: "อาคาร (ถ้ามี)", name: "building", type: "text" },
  { label: "ถนน (ถ้ามี)", name: "road", type: "text" },
  { label: "อำเภอ / เขต", name: "amphure_id", type: "text", required: true },
  { label: "ตำบล / แขวง", name: "district_id", type: "text", required: true },
  { label: "จังหวัด", name: "province_id", type: "text", required: true },
  { label: "รหัสไปรษณีย์", name: "zipcode", type: "text", required: true },
];

const ModalCreate = ({ open, onClose, selectedProduct, fetchProductData }) => {
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const [fetchData, setFetchData] = useState([]);
  const [pawn, setPawn] = useState({ checked: false, duedate: 0 });
  const [car, setCar] = useState({ checked: false, duedate: 0 });
  const [land, setLand] = useState({ checked: false, duedate: 0 });
  const [address, setAddress] = useState({
    district: "", // ตำบล tambol
    amphure: "", // อำเภอ amphoe
    province: "", // จังหวัด changwat
    zipcode: "", // รหัสไปรษณีย์ postal code
  });

  const handleSelect = (selectedOption) => {
    console.log(selectedOption);

    const updatedAddress = {
      district: selectedOption?.district || "",
      amphure: selectedOption?.amphoe || "",
      province: selectedOption?.province || "",
      zipcode: selectedOption?.zipcode || "",
    };

    // Update Formik value for the 'district' field and other relevant fields
    formik.setFieldValue("district_id", updatedAddress.district);
    formik.setFieldValue("amphure_id", updatedAddress.amphure);
    formik.setFieldValue("province_id", updatedAddress.province);
    formik.setFieldValue("zipcode", updatedAddress.zipcode);

    // Update address state
    setAddress(updatedAddress);
    console.log("Display Address", updatedAddress);
  };

  const fetchDataProduct = async () => {
    try {
      const response = await api.product.getAllProductLendAndReturnpage();
      setFetchData(response);
    } catch (error) {
      console.error("เกิดข้อผิดพลาด:", error);
    }
  };

  useEffect(() => {
    fetchDataProduct();
  }, []);

  // console.log("fetchData", fetchData);
  const handleImageDelete = (imageId) => {
    setDeletedImageIds(imageId);
  };

  useEffect(() => {
    if (selectedProduct) {
      // console.log('check image',selectedProduct)
      if (selectedProduct.Company && selectedProduct.Company.company_logo) {
        const productImageUrls = selectedProduct.Company.company_logo;
        setInitialProductUrls([
          {
            id: 1,
            picture: productImageUrls,
          },
        ]);
      }
      // if (selectedProduct.customer_image) {
      //   setInitialCustomerUrls([selectedProduct.customer_image]);
      // }
    }
    console.log({ selectedProduct });
  }, [selectedProduct]);

  useEffect(() => {
    if (selectedProduct) {
      const date_expire = new Date(selectedProduct.date_expire);
      const date_start = new Date(selectedProduct.date_start);
      const differenceInMilliseconds = date_expire - date_start;

      if (
        selectedProduct.Package_type.name_package ==
        "ระบบโรงรับจำนำ หรือร้านค้าทั่วไป"
      ) {
        setPawn({
          checked: true,
          duedate: differenceInMilliseconds / (1000 * 60 * 60 * 24),
        });
      }
      if (selectedProduct.Package_type.name_package == "ระบบรถมือสอง") {
        setCar({
          checked: true,
          duedate: differenceInMilliseconds / (1000 * 60 * 60 * 24),
        });
      }

      if (selectedProduct.Package_type.name_package == "ระบบที่ดิน") {
        setLand({
          checked: true,
          duedate: differenceInMilliseconds / (1000 * 60 * 60 * 24),
        });
      }
      formik.setValues({
        company_name: selectedProduct.Company.company_name || "",
        tax_id_number: selectedProduct.Company.tax_id_number || "",
        company_type_id:
          companyOptions.find(
            (category) =>
              category.id === selectedProduct.Company.company_type_id
          ) || null,
        owner_prefix:
          categoryOptions.find(
            (category) => category.id === selectedProduct.Company.owner_prefix
          ) || null,
        company_license: selectedProduct.Company.company_license,
        owner_name: selectedProduct.Company.owner_name || "",
        contact: selectedProduct.Company.contact || "",
        phone: selectedProduct.Company.phone || "",
        email: selectedProduct.Company.email || "",
        alley: selectedProduct.Company.alley || "",
        building: selectedProduct.Company.building || "",
        road: selectedProduct.Company.road || "",
        province_id: selectedProduct.Company.province || "",
        amphure_id: selectedProduct.Company.amphure || "",
        district_id: selectedProduct.Company.district || "",
        zipcode: selectedProduct.Company.zipcode || "",
      });
    }
  }, [selectedProduct]);

  // Function to transform object to FormData
  const tranFormObjectToFormData = (obj) => {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      if (key === "company_type_id" && typeof value === "object" && value.id) {
        formData.append(key, value.id);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (typeof item === "object" && item !== null) {
            formData.append(`${key}[${index}]`, JSON.stringify(item));
          } else {
            formData.append(`${key}[${index}]`, item);
          }
        });
      } else if (key === "files" && Array.isArray(value)) {
        value.forEach((file, index) => {
          formData.append(`files[${index}]`, file);
        });
      } else {
        formData.append(key, value !== undefined ? value : ""); // Ensure undefined values are not passed
      }
    });

    // Log formData for debugging
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    return formData;
  };

  const formik = useFormik({
    initialValues: {
      company_name: "",
      tax_id_number: "",
      owner_prefix: categoryOptions.find((option) => option.id === 1) || null, // Set default value,
      owner_name: "",
      company_type_id: companyOptions.find((option) => option.id === 1) || null, // Set default value
      company_license: false,
      contact: "",
      phone: "",
      email: "",
      alley: "",
      building: "",
      road: "",
      province_id: "",
      amphure_id: "",
      district_id: "",
      zipcode: "",
      duedate: "",
    },
    validationSchema: validationSchema,

    onSubmit: async (values, { resetForm }) => {
      const package_type = [];

      if (pawn.checked) {
        package_type.push({ id: 1, duedate: pawn.duedate });
      }
      if (car.checked) {
        package_type.push({ id: 2, duedate: car.duedate });
      }
      if (land.checked) {
        package_type.push({ id: 3, duedate: land.duedate });
      }

      const companyData = {
        company_name: values.company_name,
        tax_id_number: values.tax_id_number,
        owner_prefix: values.owner_prefix?.id || null,
        owner_name: values.owner_name,
        company_type_id: values.company_type_id?.id || null,
        company_license: values.company_license || false,
        contact: values.contact,
        phone: values.phone,
        email: values.email,
        alley: values.alley,
        building: values.building,
        road: values.road,
        district: values.district_id,
        amphure: values.amphure_id,
        province: values.province_id,
        zipcode: values.zipcode,
        package_type,
        // note: values.note,
        files: files1.map((fileObj) => fileObj.file)[0],
      };

      // Proceed with your API call
      try {
        if (selectedProduct) {
          // Update existing product
          const updateCompanyData = {
            ...companyData,
            "product.product_id": selectedProduct?.product_id,
          };
          const updateCompanyFormData =
            tranFormObjectToFormData(updateCompanyData);
          const updateCompanyResponse = await api.super_admin.updateCompany(
            selectedProduct.Company.company_id,
            updateCompanyFormData
          );

          if (updateCompanyResponse.isStatus) {
            resetForm();
            onClose();
            fetchProductData();
          }
          // handle success or error
        } else {
          // Create a new product
          const companyFormData = tranFormObjectToFormData(companyData);
          const companyResponse = await api.super_admin.createCompany(
            companyFormData
          );

          if (companyResponse.isStatus) {
            resetForm();
            onClose();
            fetchProductData();
          }
          // handle success or error
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: `${
            error.status == 403
              ? "สิทธิ์คุณไม่เพียงพอ"
              : "มีบางอย่างผิดพลาดกรุณาแจ้งซัพพอร์ต"
          }`,
          text: `${
            error.status == 403
              ? "สิทธิ์คุณไม่เพียงพอในการสร้างบริษัท"
              : "มีบางอย่างผิดพลาดกรุณาแจ้งซัพพอร์ต"
          }`,
          timer: 3000,
          showConfirmButton: false,
          customClass: {
            container: "swal2-container-custom",
          },
          didOpen: () => {
            document.querySelector(
              ".swal2-container-custom"
            ).style.zIndex = 1500;
          },
        });
      }
    },
  });

  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        html: `
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <!-- Left side icon/picture -->
            <div style="margin-right: 20px;">
              <img src="${SaveIcon}" alt="warning icon" width="300" height="300"/>
            </div>
      
            <!-- Right side text and buttons -->
            <div style="flex: 1;">
              <h2 style="font-size: 24px; color: #333;">ยืนยันการบันทึกหรือไม่</h2>
              <div id="custom-buttons" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                <!-- React buttons will be injected here -->
              </div>
            </div>
          </div>
        `,
        showCancelButton: false, // Disable default buttons
        showConfirmButton: false, // Disable default buttons
        customClass: {
          container: "swal2-container-custom",
        },
        didOpen: () => {
          document.querySelector(".swal2-container-custom").style.zIndex = 1500;

          // Render your React button components after the Swal modal opens
          ReactDOM.render(
            <>
              <GradientButton
                onClick={() => {
                  // Handle cancel behavior
                  Swal.close(); // Close Swal
                  setPawn({ checked: false, duedate: 0 });
                  setLand({ checked: false, duedate: 0 });
                  setCar({ checked: false, duedate: 0 });
                }}
                style={{ width: "100%", marginBottom: "10px" }} // Make full width
              >
                ยกเลิก
              </GradientButton>
              <GradientButtonOutline
                onClick={() => {
                  // Close the current Swal first before showing the confirmation Swal
                  Swal.close();
                  formik.resetForm();
                  setFiles1([]); // Clear product images
                  setFiles2([]); // Clear customer images
                  setPawn({ checked: false, duedate: 0 });
                  setLand({ checked: false, duedate: 0 });
                  setCar({ checked: false, duedate: 0 });
                  setInitialProductUrls([]); // Clear initial product image URLs
                  setDeletedImageIds([]); // Clear deleted image IDs
                  onClose(); // Close the modal
                }}
                style={{ width: "100%" }}
              >
                ตกลง
              </GradientButtonOutline>
            </>,
            document.getElementById("custom-buttons") // Inject React components into this div
          );
        },
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      setPawn({ checked: false, duedate: 0 });
      setLand({ checked: false, duedate: 0 });
      setCar({ checked: false, duedate: 0 });
      onClose();
    }
  };

  const renderFields = (fields) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={2}>
          <Typography variant="subtitle1">
            {field.label}
            {field.required && (
              <span style={{ marginLeft: "4px", color: "red" }}>*</span>
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={10}>
          {field.type === "autocomplete" ? (
            <Autocomplete
              id={field.name}
              options={companyOptions}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={formik.values.company_type_id}
              onChange={(event, newValue) => {
                if (!field.disabled) {
                  formik.setFieldValue("company_type_id", newValue);
                }
              }}
              disabled={field.disabled}
              sx={{
                ".MuiAutocomplete-inputRoot": {
                  height: "40px",
                  padding: "0px 0px 0px 5px !important",
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name={field.name}
                  error={
                    formik.touched[field.name] &&
                    Boolean(formik.errors[field.name])
                  }
                  helperText={
                    formik.touched[field.name] && formik.errors[field.name]
                  }
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    sx: { height: "40px" },
                  }}
                />
              )}
            />
          ) : field.name === "district_id" ? (
            <>
              <InputThaiAddress.District
                className={
                  formik.touched.district_id && formik.errors.district_id
                    ? "ant-select-status-error"
                    : ""
                }
                value={formik.values.district_id}
                onChange={(event) => {
                  console.log("New District ID:", event);
                  // Handle change event to update Formik value and mark as touched
                  formik.setFieldTouched("district_id", true);
                  formik.handleChange("district_id")(event);
                }}
                // onBlur={() => {
                //   // Mark as touched on blur
                //   formik.setFieldTouched("district_id", true);
                // }}
                onSelect={(selectedOption) => {
                  // Handle select event
                  handleSelect(selectedOption);
                  formik.setFieldTouched("district_id", true);
                }}
                style={{
                  marginBottom: "10px",
                }}
              />

              {formik.touched.district_id && formik.errors.district_id && (
                <div
                  style={{
                    color: "red",
                    fontSize: "12px",
                    // marginTop: "10px",
                    marginLeft: "15px",
                  }}
                >
                  {formik.errors.district_id}
                </div>
              )}
            </>
          ) : field.name === "amphure_id" ? (
            <>
              <div style={{ position: "relative", width: "100%" }}>
                <InputThaiAddress.Amphoe
                  className={
                    formik.touched.amphure_id && formik.errors.amphure_id
                      ? "ant-select-status-error"
                      : ""
                  }
                  value={formik.values.amphure_id}
                  onChange={(event) => {
                    formik.setFieldTouched("amphure_id", true); // Mark the field as touched
                    formik.handleChange("amphure_id")(event); // Update the form value
                  }}
                  onBlur={() => {
                    formik.setFieldTouched("amphure_id", true); // Mark as touched on blur
                  }}
                  onSelect={(selectedOption) => {
                    handleSelect(selectedOption);
                    formik.setFieldTouched("amphure_id", true); // Mark as touched on select
                  }}
                  style={{
                    marginBottom: "10px",
                  }}
                />

                {formik.touched.amphure_id && formik.errors.amphure_id && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      // marginTop: "10px",
                      marginLeft: "15px",
                    }}
                  >
                    {formik.errors.amphure_id}
                  </div>
                )}
              </div>
            </>
          ) : field.name === "province_id" ? (
            <>
              <InputThaiAddress.Province
                className={
                  formik.touched.province_id && formik.errors.province_id
                    ? "ant-select-status-error"
                    : ""
                }
                value={formik.values.province_id}
                onChange={(event) => {
                  formik.setFieldTouched("province_id", true); // Mark the field as touched
                  formik.handleChange("province_id")(event); // Update the form value
                }}
                // onBlur={() => {
                //   formik.setFieldTouched("province_id", true); // Mark as touched on blur
                // }}
                onSelect={(selectedOption) => {
                  handleSelect(selectedOption);
                  formik.setFieldTouched("province_id", true); // Mark as touched on select
                }}
                style={{
                  marginBottom: "10px",
                }}
              />
              {formik.touched.province_id && formik.errors.province_id && (
                <div
                  style={{
                    color: "red",
                    fontSize: "12px",
                    // marginTop: "10px",
                    marginLeft: "15px",
                  }}
                >
                  {formik.errors.province_id}
                </div>
              )}
            </>
          ) : field.name === "zipcode" ? (
            <>
              <InputThaiAddress.Zipcode
                className={
                  formik.touched.zipcode && formik.errors.zipcode
                    ? "ant-select-status-error"
                    : ""
                }
                value={formik.values.zipcode}
                onChange={(event) => {
                  formik.setFieldTouched("zipcode", true); // Mark the field as touched
                  formik.handleChange("zipcode")(event); // Update the form value
                }}
                onBlur={() => {
                  formik.setFieldTouched("zipcode", true); // Mark as touched on blur
                }}
                onSelect={(selectedOption) => {
                  handleSelect(selectedOption);
                  formik.setFieldTouched("zipcode", true); // Mark as touched on select
                }}
                style={{
                  marginBottom: "10px",
                }}
              />
              {formik.touched.zipcode && formik.errors.zipcode && (
                <div
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginTop: "10px",
                    marginLeft: "15px",
                  }}
                >
                  {formik.errors.zipcode}
                </div>
              )}
            </>
          ) : field.type === "checkbox" ? (
            <RadioGroup
              row
              name={field.name}
              value={formik.values.company_license}
              onChange={(e) => {
                formik.setFieldValue("company_license", e.target.value);
              }}
            >
              <FormControlLabel
                value={true}
                control={<Radio />}
                label="จดทะเบียนคิด Vat 7%"
              />
              <FormControlLabel
                value={false}
                control={<Radio />}
                label="ไม่จดทะเบียน"
              />
            </RadioGroup>
          ) : (
            <TextField
              disabled={field.disabled}
              id={field.name}
              name={field.name}
              type={field.type}
              value={formik.values[field.name]}
              onChange={formik.handleChange}
              {...getFieldProps(field.name)}
              error={
                formik.touched[field.name] && Boolean(formik.errors[field.name])
              }
              helperText={
                formik.touched[field.name] && formik.errors[field.name]
              }
              fullWidth
              InputProps={{
                sx: { height: "40px" },
                inputProps: {
                  style: {
                    mozappearance: "textfield", // Hide up/down arrows in Firefox
                    webkitappearance: "none", // Hide up/down arrows in Chrome/Safari
                    appearance: "none", // Hide up/down arrows in other browsers
                  },
                  // maxLength:
                  //   field.name === "amphure_id"
                  //     ? 13
                  //     : field.name === "district_id"
                  //     ? 10
                  //     : undefined, // Set max length
                  inputMode: field.type === "text" ? "numeric" : undefined, // Ensure numeric keyboard on mobile
                  pattern: field.type === "text" ? "[0-9]*" : undefined, // Restrict input to numbers
                },
              }}
            />
          )}
        </Grid>
      </React.Fragment>
    ));
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
      sx={{
        borderRadius: "8px",
      }}
    >
      <DialogTitle>
        <Typography variant="h4">
          {selectedProduct ? "แก้ไขบริษัท/ร้านค้า" : "สร้างบริษัท/ร้านค้า"}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} sx={{ padding: 3 }}>
            <Grid item xs={12}>
              <Typography sx={{ mb: 3 }} variant="h4">
                บริษัท/ร้านค้า
              </Typography>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {renderFields(productFields)}

                {/* Owner Name Field */}
                <Grid container spacing={2} sx={{ ml: "1px" }}>
                  <Grid item xs={12} sm={2}>
                    <Typography variant="subtitle1">
                      ชื่อเจ้าของร้าน/ผู้ทำธุรกรรม
                      <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Autocomplete
                      id="owner_prefix"
                      options={categoryOptions}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      value={formik.values.owner_prefix} // Set the default value
                      onChange={(event, newValue) => {
                        formik.setFieldValue("owner_prefix", newValue); // Update Formik value on change
                      }}
                      disabled={false} // Adjust if needed
                      sx={{
                        ".MuiAutocomplete-inputRoot": {
                          height: "40px",
                          padding: "0px 0px 0px 5px !important",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="owner_prefix"
                          error={
                            formik.touched.owner_prefix &&
                            Boolean(formik.errors.owner_prefix)
                          }
                          helperText={
                            formik.touched.owner_prefix &&
                            formik.errors.owner_prefix
                          }
                          fullWidth
                          InputProps={{
                            ...params.InputProps,
                            sx: { height: "40px" },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      id="owner_name"
                      name="owner_name"
                      value={formik.values.owner_name}
                      onChange={formik.handleChange}
                      {...getFieldProps("owner_name")}
                      error={
                        formik.touched.owner_name &&
                        Boolean(formik.errors.owner_name)
                      }
                      helperText={
                        formik.touched.owner_name && formik.errors.owner_name
                      }
                      fullWidth
                      InputProps={{
                        sx: { height: "40px" },
                        inputProps: {
                          mozappearance: "textfield", // Hide up/down arrows in Firefox
                          webkitappearance: "none", // Hide up/down arrows in Chrome/Safari
                          appearance: "none",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Company Type Field */}
                <Grid container spacing={2} sx={{ ml: "1px" }}>
                  <Grid item xs={12} sm={2}>
                    <Typography variant="subtitle1">
                      ประเภทระบบ
                      <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                    </Typography>
                  </Grid>
                  {/* Column containing Checkbox and TextField */}
                  <Grid item xs={12} sm={5}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start" // Align items to the start (left) of the container
                    >
                      {/* Pawn */}
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={pawn.checked}
                          onChange={(e) =>
                            setPawn({ ...pawn, checked: e.target.checked })
                          }
                          disabled={selectedProduct ? true : false}
                        />
                        <Typography variant="body1" sx={{ ml: 1 }}>
                          ระบบโรงจำนำ หรือร้านค้าทั่วไป
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <TextField
                          id="pawn_duedate"
                          name="pawn_duedate"
                          value={pawn.duedate}
                          onChange={(e) =>
                            setPawn({ ...pawn, duedate: e.target.value })
                          }
                          disabled={
                            !pawn.checked || selectedProduct ? true : false
                          }
                          fullWidth
                          InputProps={{ sx: { height: "40px" } }}
                        />
                        <Typography variant="body1" sx={{ ml: 1 }}>
                          วัน
                        </Typography>
                      </Box>

                      {/* Car */}
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={car.checked}
                          onChange={(e) =>
                            setCar({ ...car, checked: e.target.checked })
                          }
                          disabled={selectedProduct ? true : false}
                        />
                        <Typography variant="body1" sx={{ ml: 1 }}>
                          ระบบรถมือสอง
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <TextField
                          id="car_duedate"
                          name="car_duedate"
                          value={car.duedate}
                          onChange={(e) =>
                            setCar({ ...car, duedate: e.target.value })
                          }
                          disabled={
                            !car.checked || selectedProduct ? true : false
                          }
                          fullWidth
                          InputProps={{ sx: { height: "40px" } }}
                        />
                        <Typography variant="body1" sx={{ ml: 1 }}>
                          วัน
                        </Typography>
                      </Box>

                      {/* land */}
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={land.checked}
                          disabled={selectedProduct ? true : false}
                          onChange={(e) =>
                            setLand({ ...land, checked: e.target.checked })
                          }
                        />
                        <Typography variant="body1" sx={{ ml: 1 }}>
                          ระบบที่ดิน
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <TextField
                          id="land_duedate"
                          name="land_duedate"
                          value={land.duedate}
                          onChange={(e) =>
                            setLand({ ...land, duedate: e.target.value })
                          }
                          disabled={
                            !land.checked || selectedProduct ? true : false
                          }
                          fullWidth
                          InputProps={{ sx: { height: "40px" } }}
                        />
                        <Typography variant="body1" sx={{ ml: 1 }}>
                          วัน
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                {renderFields(productFields2)}
                <Grid item xs={12}>
                  <Typography variant="subtitle1" sx={{ mb: 2 }}>
                    โลโก้บริษัท
                  </Typography>
                  <CustomDropzone
                    files={files1}
                    initialUrls={initialProductUrls}
                    setFiles={setFiles1}
                    setError={setError1}
                    onDelete={handleImageDelete}
                  />
                  {error1 && (
                    <Typography variant="caption" color="error">
                      {error1}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={handleCancel}
        >
          {selectedProduct ? "ยกเลิก" : "กลับ"}
        </GradientButtonOutline>
        <GradientButton
          variant="contained"
          onClick={formik.handleSubmit}
          type="submit"
        >
          {selectedProduct ? "บันทึก" : "บันทึกและพิมพ์"}
        </GradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCreate;
